import React from 'react';

interface SelectionCriteriaProps {
  children?: React.ReactNode;
}

export default function SelectionCriteria({ children }: SelectionCriteriaProps) {
  // Дефолтный контент, если нет children
  const defaultContent = (
    <ul className="list-disc pl-5 space-y-2">
      <li>
        <strong>Мета використання</strong> - Різні типи металу мають різні властивості,
        які роблять їх більш або менш придатними для конкретних застосувань.
      </li>
      <li>
        <strong>Механічні властивості</strong> - Міцність, пластичність, твердість та інші 
        характеристики, що визначають поведінку металу під навантаженням.
      </li>
      <li>
        <strong>Корозійна стійкість</strong> - Здатність металу противитися корозії в 
        різних середовищах.
      </li>
      <li>
        <strong>Зварюваність</strong> - Здатність металу утворювати надійні зварні з&apos;єднання.
      </li>
      <li>
        <strong>Ціна та доступність</strong> - Баланс між вартістю та необхідними 
        характеристиками.
      </li>
    </ul>
  );

  return (
    <div className="my-6 p-4 bg-gray-50 rounded-lg">
      <h3 className="text-xl font-semibold mb-3">Критерії вибору</h3>
      {children || defaultContent}
    </div>
  );
}